/* global Waypoint TimelineLite  */

// Centered laptop dashboard animation
(function () {
	var tl = new TimelineLite();
	var ease = window.Power4.easeInOut;
	var animationStarted = false;
	var vmDashboard = document.querySelector("#pci-unified-dashboard .q-laptop");
	vmDashboard.classList.add("q-laptop--will-animate");

	new Waypoint({
		element: document.getElementById('pci-unified-dashboard'),
		offset: "80%",
		handler: function(direction) {
			if (direction === "down" && !animationStarted) {
				tl.addLabel("start").fromTo("#pci-unified-dashboard .q-laptop", 0.75, { x: "10%", autoAlpha: 0 }, { x: "0%", autoAlpha: 1, ease: ease});
			}

			animationStarted = true;
		}
	});
}());